export default __webpack_public_path__ + "media/vue/img/whence/target-icon-0f9b54cf30cdace08f7e75d2c8ea49a8.png";